var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41016 9.33301C7.5699 10.3718 7.76394 11.4878 7.99965 12.6663C8.58582 15.5971 9.17198 17.626 9.64485 19.2627C10.2476 21.3491 10.6663 22.7984 10.6663 24.6663C10.6663 27.9997 9.33299 30.6663 9.33299 30.6663H22.6663C22.6663 30.6663 21.333 27.9997 21.333 24.6663C21.333 22.7984 21.7517 21.3492 22.3544 19.2629C22.8273 17.6261 23.4135 15.5972 23.9997 12.6663C24.2354 11.4878 24.4294 10.3718 24.5891 9.33301H17.3329C15.5734 9.33301 15.2999 10.8191 15.0417 12.2224C14.8107 13.4775 14.5919 14.6663 13.3329 14.6663C12.0739 14.6663 11.8551 13.4775 11.6242 12.2224C11.3659 10.8191 11.0925 9.33301 9.33292 9.33301H7.41016Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.59 9.33301H17.3335C15.574 9.33301 15.3005 10.8191 15.0423 12.2224C14.8113 13.4775 14.5926 14.6663 13.3335 14.6663C12.0745 14.6663 11.8557 13.4775 11.6248 12.2224C11.3665 10.8191 11.0931 9.33301 9.33353 9.33301H7.41102C7.17787 7.81682 7.0178 6.46517 6.90791 5.32386C6.69617 3.12491 8.45802 1.33301 10.6671 1.33301H25.3339C25.3339 1.33301 25.3339 4.49558 24.59 9.33301Z",
    fill: "url(#paint0_linear_887_4784)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4784",
    x1: 25.3339,
    y1: 6.66634,
    x2: 6.89063,
    y2: 6.65313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.ac8daf7f8bc3b07ef2c27929d3939572.svg";
export { ForwardRef as ReactComponent };